import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { Table } from 'react-bootstrap';
import { IDetailViewModel, ICurrency } from '../Types';
import ReceivableDetail from './ReceivableDetail';
import InvoiceTypeLegend from '../../invoice/InvoiceTypeLegend';

interface IProps {
    currency: ICurrency;
    details: IDetailViewModel[];
    site: string;
    customer: number;
}

const ReceivableDetails = (props: IProps) => {
    return (
        <fieldset>
            <legend>
                {Translate('receivable/details/legend')}
                {props.site ? ' - ' + props.site : ''}
            </legend>
            <InvoiceTypeLegend showPastDue={false} />
            <Table responsive className="receivables-table">
                <thead>
                    <tr>
                        <th>
                            <u>{Translate('receivable/details/headers/date/unselected')}</u>
                        </th>
                        <th>
                            <u>{Translate('receivable/details/headers/customer')}</u>
                        </th>
                        <th>
                            <u>{Translate('receivable/details/headers/invoice')}</u>
                        </th>
                        <th>
                            <u>{Translate('receivable/details/headers/amount')}</u>
                        </th>
                        <th>
                            <u>{Translate('receivable/details/headers/paid')}</u>
                        </th>
                        <th>
                            <u>{Translate('receivable/details/headers/exchange-difference')}</u>
                        </th>
                        <th>
                            <u>{Translate('receivable/details/headers/result')}</u>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {props.details &&
                        props.details
                            .sort((a, b) => a.customer.localeCompare(b.customer))
                            .map((d: IDetailViewModel, i: number) => {
                                return (
                                    <ReceivableDetail
                                        date={d.date}
                                        customer={d.customer}
                                        invoice={d.invoice}
                                        amount={d.amount}
                                        paid={d.paid}
                                        balance={d.balance}
                                        currency={props.currency}
                                        exchangeDifference={d.exchangeDifference}
                                        key={i}
                                        rowClass={
                                            d.isCredit
                                                ? 'receviables-row-credit'
                                                : 'receviables-row-debit'
                                        }
                                    />
                                );
                            })}
                </tbody>
            </Table>
        </fieldset>
    );
};

export default ReceivableDetails;
